module.exports = __webpack_public_path__ + "img/swipe.c9b1866.svg";